<template>
    <div class="carousel">
        <div
            class="image-container p-4 bg-white shadow-sm rounded"
            :class="index == currentIndex ? 'd-flex flex-column justify-content-center align-items-center' : 'd-none'"
            v-for="(item, index) in items"
            :key="index"
            v-show="index == currentIndex"
        >
            <div>
                <img :src="item.image" :alt="item.title" class="item-image img-fluid" />
            </div>

            <div class="my-carousel-content p-4 bg-white shadow-sm rounded">
                <h2 class="text-primary font-weight-bold mb-3">{{ item.title }}</h2>
                <div class="news-content">
                    <p class="text-muted" v-html="item.description"></p>
                </div>
                <div class="news-meta mt-3">
                    <small class="text-secondary">
                        <i class="far fa-calendar-alt mr-1"></i> {{ new Date().toLocaleDateString() }}
                    </small>
                </div>
            </div>
            <div class="my-buttons d-flex justify-content-around">
                <b-btn v-for="(btn, i) in item.buttons" @click="btn.action" :variant="btn.variant ?? 'primary'" :key="`btn_${i}`">{{ btn.label }}</b-btn>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center position-absolute w-100" style="top: 50%; transform: translateY(-50%);">
            <b-btn variant="link" @click="prev" class="carousel-nav-btn" style="font-size: 2rem; color: #666;">
                <i class="fas fa-chevron-circle-left"></i>
            </b-btn>
            <b-btn variant="link" @click="next" class="carousel-nav-btn" style="font-size: 2rem; color: #666;">
                <i class="fas fa-chevron-circle-right"></i>
            </b-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: [],
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['sm', 'md', 'lg'].includes(value),
        },
    },
    data() {
        return {
            currentIndex: 0,
        }
    },
    computed: {
        width() {
            const w = {
                sm: 600,
                md: 1024,
                lg: 1280,
            }[this.size]
            const width = Math.min(window.innerWidth - 40, w)
            return width
        },
        height() {
            const h = {
                sm: 450,
                md: 768,
                lg: 960,
            }[this.size]
            const height = Math.min(window.innerHeight - 40, h)
            return height
        },
    },
    methods: {
        next() {
            this.currentIndex = (this.currentIndex + 1) % this.items.length
        },
        prev() {
            this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length
        },
    },
}
</script>

<style scoped>
.carousel {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
}

.image-container {
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.item-image {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
}

.my-carousel-content {
    width: 100%;
    padding: 1rem;
    text-align: center;
}

@media (max-width: 768px) {
    .carousel {
        padding: 0 1rem;
    }
    
    .item-image {
        max-height: 60vh;
    }
}
</style>
